import React from 'react';
import styled from 'styled-components';
import {
  AgricultureIcon,
  ConstructionIcon,
  HealthcareIcon,
  ItIcon,
  TourismIcon,
  MiscIcon,
} from '../Icons';

const Wrapper = styled.div`
  display: flex;
  margin-left: 0.5rem;
  flex-direction: column;
  justify-content: center;
  > div > svg {
    width: 20px;
    height: 20px;
    margin-left: 0.5rem;
  }
`;

const SkillBlock = ({ skill }) => {

  const skills = [
    {
      name: 'Information and Communications Technology',
      label: 'ITC',
      icon: <ItIcon />
    },
    {
      name: 'Tourism and Hospitality',
      label: 'Tourism and Hospitality',
      icon: <TourismIcon />
    },
    {
      name: 'Construction, Engineering, and Manufacturing',
      label: 'Construction, Engineering, and Manufacturing',
      icon: <ConstructionIcon />
    },
    {
      name: 'Agriculture, Horticulture, and Food Processing',
      label: 'Agriculture, Horticulture, and Food Processing',
      icon: <AgricultureIcon />
    },
    {
      name: 'Healthcare',
      label: 'Healthcare',
      icon: <HealthcareIcon />
    },
    {
      name: 'Not specified',
      label: 'Not specified',
      icon: <MiscIcon />
    }
  ];

  const currentSkill = (value) => skills.find((skill) => skill.name === value);

  if (!skill || !skill.length) return null;
  return (
    <Wrapper>
      {skill?.map((sk) => {
        const{ label, icon } = currentSkill(sk);
        return (
          <div>
          <span>{label}</span>
          { icon }
          </div>
        )
      })}
    </Wrapper>
  )
};

export default SkillBlock;
